/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var core = require('../core');
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var __ol = _interopDefault(require('openlayers'));
var Observable = require('rxjs/Observable');
var interval = require('rxjs/observable/interval');
var first = require('rxjs/operator/first');
var map = require('rxjs/operator/map');
var skipWhile = require('rxjs/operator/skipWhile');
var toPromise = require('rxjs/operator/toPromise');

var Cluster = __ol.source.Cluster;

var Builder = function () {
  function Builder() {
    _classCallCheck(this, Builder);
  }

  _createClass(Builder, [{
    key: 'getSource',

    /**
     * @return {ol.source.Vector|undefined}
     */
    value: function getSource() {
      return this.source;
    }
    /**
     * @param {ol.source.Vector|undefined} value
     * @returns {Builder}
     */

  }, {
    key: 'setSource',
    value: function setSource(value) {
      this.source = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setAttributions',
    value: function setAttributions(value) {
      this.attributions = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setDistance',
    value: function setDistance(value) {
      this.distance = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setGeometryFunction',
    value: function setGeometryFunction(value) {
      this.geometryFunction = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setLogo',
    value: function setLogo(value) {
      this.logo = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setProjection',
    value: function setProjection(value) {
      this.projection = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setWrapX',
    value: function setWrapX(value) {
      this.wrapX = value;
      return this;
    }

    /**
     * @param key
     * @param value
     * @return {void}
     */

  }, {
    key: 'set',
    value: function set(key, value) {
      this.values || (this.values = {});
      this.values[key] = value;
    }

    /**
     * @return {ol.source.Cluster}
     */

  }, {
    key: 'build',
    value: function build() {
      core.assert.ok(this.source, 'source is provided');

      var source = new Cluster({
        attributions: this.attributions,
        distance: this.distance,
        geometryFunction: this.geometryFunction,
        logo: this.logo,
        projection: this.projection,
        source: this.source,
        wrapX: this.wrapX
      });
      source.setProperties(this.values);

      return source;
    }

    /**
     * @return {Promise<ol.source.Cluster>}
     */

  }, {
    key: 'promise',
    value: function promise() {
      var _context,
          _this = this;

      return (_context = (_context = (_context = (_context = interval.interval.call(Observable.Observable, 100), skipWhile.skipWhile).call(_context, function () {
        return !_this.source;
      }), first.first).call(_context), map.map).call(_context, this.build.bind(this)), toPromise.toPromise).call(_context);
    }
  }]);

  return Builder;
}();

var props = {
  distance: {
    type: Number,
    default: 20
  },
  /**
   * Geometry function factory
   * @type {function(): (function(f: ol.Feature): ol.geom.SimpleGeometry|undefined)} geomFuncFactory
   */
  geomFuncFactory: {
    type: Function,
    default: defaultGeomFuncFactory
  }
};

var computed = {
  geomFunc: function geomFunc() {
    return this.geomFuncFactory();
  }
};

var methods = {
  /**
   * @return {Promise<ol.source.Cluster>}
   * @protected
   */
  createSource: function createSource() {
    // partial setup of ol.source.Cluster with the help of SourceBuilder class
    /**
     * @type {SourceBuilder}
     * @private
     */
    this._sourceBuilder = new Builder().setAttributions(this.attributions).setDistance(this.distance).setGeometryFunction(this.geomFunc).setLogo(this.logo).setProjection(this.projection).setWrapX(this.wrapX);

    return this._sourceBuilder.promise();
  },

  /**
   * @return {Object}
   * @protected
   */
  getServices: function getServices() {
    return core.mergeDescriptors(core.vectorSource.methods.getServices.call(this), core.sourceContainer.methods.getServices.call(this));
  },

  /**
   * @return {{
   *     setSource: function(ol.source.Source): void,
   *     getSource: function(): ol.source.Source
   *   }|undefined}
   * @protected
   */
  getSourceTarget: function getSourceTarget() {
    return this._sourceBuilder;
  }
};

var watch = {
  distance: function distance(value) {
    if (this.$source && value !== this.$source.getDistance()) {
      this.$source.setDistance(value);
    }
  }
};

var Source = {
  name: 'vl-source-cluster',
  mixins: [core.vectorSource, core.sourceContainer],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch

  /**
   * @returns {function(f: ol.Feature): ol.geom.SimpleGeometry|undefined}
   */
};function defaultGeomFuncFactory() {
  return function (feature) {
    var geometry = feature.getGeometry();
    if (!geometry) return;

    var coordinate = core.geomHelper.pointOnSurface(geometry);
    if (coordinate) {
      return core.geomHelper.point(coordinate);
    }
  };
}

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/cluster-source/index.js
// module id = 1178
// module chunks = 1